import { Theme } from '@material-ui/core';
import { AlertClassKey } from '@material-ui/lab/Alert';
import { AlertTitleClassKey } from '@material-ui/lab/AlertTitle';

export const muiAlertOverride = (theme: Theme): Theme['overrides'] => ({
  MuiAlert: {
    root: {
      borderRadius: 0,
      maxWidth: '320px',
      fontWeight: 400,
    },
  },
  MuiAlertTitle: {
    root: {
      fontSize: '16px',
      fontWeight: 500,
    },
  },
});

declare module '@material-ui/core/styles/overrides' {
  export interface ComponentNameToClassKey {
    MuiAlert: AlertClassKey;
    MuiAlertTitle: AlertTitleClassKey;
  }
}
